<template>
    <div class="multiple-choice-with-additional-answers">
        <div class="answers">
            <h1>{{ props.question.question }}</h1>
            
            <div class="question-description" v-show=props.question.description>
                <p>{{ props.question.description }}</p>
            </div>

            <div class="all-answers">
                <transition-group name="list">
                    <div v-for="answer of userAnswers" :key="answer.key" class="answer">                        
                            <div class="answer-details" v-show="!answer.editing">
                                <CheckBoxAnswer
                                    :answer="answer.answer"
                                    :initiallySelected="answer.selected"
                                    :keyName="answer.key"
                                    @checkbox-change="toggleSelectAnswer"
                                />                            
                                <v-icon                                    
                                    name="hi-pencil"
                                    :hover="true"
                                    animation="wrench"
                                    fill="#2f24c1"
                                    class="icon"
                                    @click="editAnswer(answer)"
                                />
                                <v-icon
                                    name="ri-delete-bin-4-fill"
                                    :hover="true"
                                    animation="wrench"
                                    fill="#dd0a35"
                                    class="icon"
                                    @click="removeAnswer(answer)"
                                /> 
                            </div>
                            <div class="input-container" v-show="answer.editing">                                
                                <div class="inputs">
                                    <input                                    
                                        v-model="answer.answer"                                    
                                        type="text"
                                        placeholder="Nytt element.."
                                    />
                                    <button class="app-btn" @click="updateAnswer(answer)">Lagre</button>
                                    <button class="app-btn" @click="stopEdit(answer)">Avbryt</button>
                               </div>
                            </div>
                    </div>
                </transition-group>
                <div class="new-answer">
                    <button class="app-btn" @click="addNewAnswer">Legg til ny</button>               
                </div>
            </div>
        </div>

        <button class="app-btn next-btn" @click="handleClick">Neste</button>
    </div>
</template>

<script setup>
import { defineProps, ref, defineEmits} from 'vue';
import { notify } from '@kyvg/vue3-notification';
import CheckBoxAnswer from '../CheckBoxAnswer.vue';
import { LocalStorageService } from '@/services/LocalStorageService';

const localStorageService = new LocalStorageService();

const props = defineProps(['question']);
const emit = defineEmits(['answered']);

const userAnswers = ref([...localStorageService.getQuestionState(props.question.id).userAnswers]);

const toggleSelectAnswer = ({ selected, key}) => {    
    const answerToUpdate = userAnswers.value.find(userAnswer => userAnswer.key === key);

    answerToUpdate.selected = selected;

    localStorageService.updateQuestionState(props.question.id, {
        userAnswers: [...userAnswers.value]
    });
};

const addNewAnswer = () => {
    userAnswers.value = [...userAnswers.value, { answer: 'Nytt element', key : localStorageService.uuidv4(), selected: true, editing: true, new: true}];

    localStorageService.updateQuestionState(props.question.id, {
        userAnswers: [...userAnswers.value]
    });
};

const updateAnswer = (answer) => {
    answer.editing = false;
    answer.new = false;
    answer.answerBeforeEdit = null;

    localStorageService.updateQuestionState(props.question.id, {
        userAnswers: [...userAnswers.value]
    });
};

const editAnswer = answer => {    
    answer.editing = true;
    answer.answerBeforeEdit = answer.answer 
};

const stopEdit = answer => {    
    answer.editing = false; 
    answer.answer = answer.answerBeforeEdit;
    
    if  (answer.new)
    {
        removeAnswer(answer)
    }

};

const removeAnswer = answer => {
    userAnswers.value = userAnswers.value.filter(userAnswer => userAnswer.key !== answer.key);

    localStorageService.updateQuestionState(props.question.id, {
        userAnswers: [...userAnswers.value]
    });
};

const handleClick = () => {
    if (userAnswers.value.every(userAnswer => !userAnswer.selected)) {
        return notify({ title: 'Valg', text: 'Kryss av minst ett av valgene.', type: 'error' });
    }

    emit('answered');
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.multiple-choice-with-additional-answers {   
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 5%;

    @media (max-width: 600px) {
        justify-content: flex-start;
        height: auto;
        margin: 100px 0;
    }

    .answers {
        .all-answers {
            .new-answer {
                margin-top: 40px;
            }
            .answer {
                display: flex;
                flex-direction: column;
                
                .answer-details {
                    display: flex;
                    align-items: center;
                    flex-direction: row;

                    p {
                        margin-right: 20px;
                    }
                    .icon {
                        margin: 0 5px;
                        cursor: pointer;

                        &:first-of-type {
                            margin-left: 20px;
                        }
                    }
                }
            }

            .input-container {
                display: flex;
                flex-direction: column;

                align-items:  flex-start;
                font-size: 16px;
                margin-top: 10px;

                .inputs{
                    input {
                        font-size: 16px;
                        padding: 5px;
                        font-family: 'Roboto', sans-serif;
                        color: $text-color;
                        letter-spacing: 1px;
                        border: 1px solid $primary-color;
                        border-radius: 3px;
                    }                

                    button {
                        margin-left: 10px;
                        font-size: 14px;
                        padding: 6px 30px;
                    }
                }                  
            }
        }
    }

    .next-btn {
        margin: 50px 0;
    }
}
</style>
